module.exports = __webpack_public_path__ + "img/logo-simbolo.60c4f235.png";